import { SharedDictionary } from 'types/i18n';
import { UnreachableError } from 'utils/errors';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { datesDictionaryRu } from 'i18n/ru/datesDictionaryRu';
import { CardPaymentStatus } from 'types/state';
import { M8Currency, M8RateDTO } from 'services/production/types';

export const createCurrencySymbol = (currency: M8Currency) => {
  switch (currency) {
    case 'BYN':
      return 'Br';
    case 'EUR':
      return '€';
    case 'RUB':
      return '₽';
    case 'USD':
      return '$';
    default:
      throw new UnreachableError(currency);
  }
};

export const sharedDictionaryRu: SharedDictionary = {
  dates: datesDictionaryRu,

  aboutAppLinkText: 'О программе',
  userAgreementLinkText: 'Пользовательское соглашение',
  privacyPolicyLinkText: 'Политика конфиденциальности',
  licenseAgreementText: 'Лицензионное соглашение',
  partnerCodeTooltipText: 'Промокод скопирован в буфер',
  supportLinkText: 'Справочный центр',
  employeeLinkText: 'AGM для подчиненного',
  registerDemoLinkText: 'Демоверсия',
  licensesTooltipText:
    'Лицензии — это количество сотрудников, которых клиент зарегистрировал в программе. Значение обновляется раз в сутки.',

  partnerFullName(partnerProfile) {
    return normalizeProfileLike(partnerProfile).toFullName();
  },
  orgStaffCount(orgStaffCount) {
    switch (orgStaffCount) {
      case 'large':
        return 'более 500';
      case 'medium':
        return 'до 500';
      case 'small':
        return 'до 100';
      default:
        return '';
    }
  },
  giroPaymentStatusValue(status) {
    switch (status) {
      case 'CLIENT_FOUND':
        return 'Клиент найден';
      case 'CLIENT_NOT_FOUND':
        return 'Клиент не найден';
      case 'OK':
        return 'Зачислен';
      case 'FAILED':
        return 'Ошибочный';
      case 'WAITING':
        return 'В ожидании';
      default:
        throw new UnreachableError(status);
    }
  },
  cardPaymentStatusValue: (status: CardPaymentStatus) => {
    switch (status) {
      case 'CREATED':
        return 'Создан';
      case 'DECLINED':
        return 'Отклонен';
      case 'REVERSED':
        return 'Возвращен';
      case 'DEPOSITED':
        return 'Зачислен';
      default:
        return '-';
    }
  },
  paymentTransactionText(transaction) {
    return sharedDictionaryRu.moneyAmountText(
      transaction.amount,
      transaction.currency
    );
  },
  exhangeRateText(rate: M8RateDTO) {
    const leftAmountText = sharedDictionaryRu.moneyAmountText(
      rate.value,
      rate.valueCurrency
    );

    const rightAmountText = sharedDictionaryRu.moneyAmountText(
      rate.scale,
      rate.currency
    );

    return `${leftAmountText} за ${rightAmountText}`;
  },
  moneyAmountText(amount, currency) {
    const formatter = new Intl.NumberFormat('ru', {
      style: 'currency',
      currency,
    });

    return formatter.format(amount);
  },
};
